import SmoothScroll from 'smooth-scroll';

export default {

  init() {

    this.onReady = this.onReady.bind( this );
    window.onload = this.onReady;

    $( document ).on( 'click', '.js-maze-thumb', this.triggerMazeCircle );

  },

  onReady() {

    setTimeout( () => {
      this.initSmoothScroll();
    }, 200 );

  },

  initSmoothScroll() {

    this.scroll = new SmoothScroll( 'a[href*="#"]', {
      offset: '50',
    });

    if ( window.location.hash != '' ) {
      this.scroll.animateScroll(
        document.querySelector( window.location.hash )
      );
    }

  },

  triggerMazeCircle( event ) {

    const index = event.currentTarget.dataset.circle_index;
    $( event.currentTarget ).parents( '.js-maze-circles' ).find( '.js-maze-image.is-active' ).removeClass( 'is-active' );

    $( event.currentTarget ).parents( '.js-maze-circles' ).find( '.js-maze-image[data-circle_index="' + index + '"]' ).addClass( 'is-active' );

  },
}



// WEBPACK FOOTER //
// ./scripts/modules/content.js